module.exports = __webpack_public_path__ + "static/kevin.0b7ce4fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/kevin.jpg
// module id = ./assets/kevin.jpg
// module chunks = 63538265317374 137408898365125 269238729700051